<template>
  <div :class="containerClass">
    <div class="text-center">
      <img
        v-if="image"
        :src="image"
        :alt="imageAlt"
        draggable="false"
        class="mx-auto"
        :class="imageClass || 'max-w-44'"
      />
      <u-icon v-else-if="icon" :name="icon" class="text-heroblue/75" :class="[fontSize.icon, {'animate-spin': spinIcon}]" />
      <h3 class="mt-8 mb-4 break-long-string" :class="fontSize.h">{{heading}}</h3>
      <slot name="description">
        <p class="text-gray-500" :class="fontSize.p">{{ description }}</p>
      </slot>
    </div>
    <slot />
  </div>
</template>

<script setup>
  const props = defineProps({
    heading: String,
    description: String,
    icon: String,
    size: String,
    image: String,
    imageAlt: {
      type: String,
      default: ''
    },
    imageClass: String,
    spinIcon: Boolean,
    bordered: Boolean
  });

  const isCentered = inject('emptyStateCentered', false);

  const containerClass = computed(() => {
    if (props.bordered) {
      return 'border border-gray-200 dark:border-gray-700 rounded-md p-4 bg-white dark:bg-charcoal/50';
    }

    if (props.size === 'xs') {
      return isCentered ? '' : 'pt-2';
    } else {
      return isCentered
        ? 'w-full max-w-3xl mx-auto'
        : 'w-full max-w-3xl mx-auto pt-8 sm:pt-16';
    }
  });

  const fontSize = computed(() => {
    if (props.size === 'xs') {
      return {
        icon: 'text-4xl mb-1',
        h: 'text-xl sm:text-xl font-semibold',
        p: 'text-sm sm:text-base',
      };
    } else {
      return {
        icon: 'text-6xl sm:text-8xl mb-2',
        h: 'text-3xl sm:text-4xl font-serif',
        p: 'text-base sm:text-xl'
      };
    }
  });
</script>
